import axios from 'axios';

export function get() {
  const WHATTIMEISIT_API = '/api/v1/whattimeisit';

  return new Promise((resolve, reject) => {
    axios
      .get(WHATTIMEISIT_API)
      .then(response => {
        resolve(response.data);
      })
      .catch(reject);
  });
}



// WEBPACK FOOTER //
// ./src/services/whatTimeIsIt/WhatTimeIsItService.js